import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useApp } from '../context/AppContext';
import ProjectCard from './ProjectCard';

const SectionHeading = ({ title, linkLabel, to }) => (
  <div className="flex items-end justify-between gap-4 mb-8">
    <div>
      <div className="h-1 w-12 bg-gobra-terracotta rounded-full mb-3" />
      <h2 className="font-title text-2xl md:text-4xl font-bold text-gobra-slate">{title}</h2>
    </div>
    {linkLabel && (
      <Link to={to} className="shrink-0 hidden sm:flex items-center gap-1.5 text-sm font-medium text-gobra-green hover:text-gobra-terracotta transition-colors">
        {linkLabel} <ArrowRight className="h-4 w-4" />
      </Link>
    )}
  </div>
);

export { SectionHeading };

const LatestProjects = () => {
  const { t, projects } = useApp();
  const list = [...projects].sort((a, b) => (b.featured ? 1 : 0) - (a.featured ? 1 : 0)).slice(0, 8);
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-8 py-16 md:py-24">
      <SectionHeading title={t('latest_projects')} linkLabel={t('view_all_projects')} to="/projects" />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
        {list.map((p) => <ProjectCard key={p.id} project={p} />)}
      </div>
      <div className="mt-10 flex justify-center sm:hidden">
        <Link to="/projects" className="flex items-center gap-1.5 text-sm font-medium text-gobra-green">
          {t('view_all_projects')} <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </section>
  );
};

export default LatestProjects;
